/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />
/// <reference path="../base/base.service.ts" />
/// <reference path="../login/login.model.ts" />

module Eseebase {
    export class OrganizationService {
        constructor(private $http: ng.IHttpService, private baseService: BaseService, private $q: ng.IQService, private companyService: CompanyService, private $timeout: ng.ITimeoutService) { }

        private static orgUnits: OrganizationalUnitViewModel[];
        private static isLoadingOrgUnits: boolean;

        public list(): ng.IPromise<OrganizationalUnitViewModel[]> {
            var vm = this;
            if (OrganizationService.isLoadingOrgUnits) {
                return this.$timeout(() => {
                    return vm.list();
                }, 500).then(d => d);
            }
            else {
                if (OrganizationService.orgUnits == null) {
                    OrganizationService.isLoadingOrgUnits = true;
                    return this.baseService.get('organization/{companyNumber}/list').then(data => {
                        OrganizationService.orgUnits = <OrganizationalUnitViewModel[]>data.data;
                        OrganizationService.isLoadingOrgUnits = false;
                        return OrganizationService.orgUnits;
                    }, () => {
                        OrganizationService.isLoadingOrgUnits = false;
                    });
                }
                else {
                    return this.$q((resolve, refect) => {
                        resolve(OrganizationService.orgUnits);
                    });
                }
            }
        }

        public resetOrgUnits() {
            OrganizationService.orgUnits = null;
        }

        public getByCompany(companyNumber: string) {
            return this.baseService.get('organization/' + companyNumber + '/list').then(data => data.data);
        }

        public save(organization: OrganizationalUnitViewModel) {
            return this.baseService.post('organization/{companyNumber}/save', organization).then(d => d.data);
        }

        public delete(id: string) {
            return this.baseService.delete('organization/{companyNumber}/' + id);
        }

        public getIndoorDataCsv(companyNumber: string, associationNumber: string) {
            return this.baseService.get('buildingpart/' + companyNumber + '/indoor/' + associationNumber + '/csv').then(data => data.data);
        }

        public getFloorplanDataZip(companyNumber: string, associationNumber: string) {
            return this.baseService.getArrayBuffer('floorplan/' + companyNumber + '/' + associationNumber + '/zip').then(data => data.data);
        }

        public getDetails(orgUnitId: string) {
            return this.baseService.get('organization/{companyNumber}/details?id=' + orgUnitId).then(data => data.data);
        }

        public getTenderGroupId(orgUnitId: string) {
            return this.baseService.get('organization/{companyNumber}/tendergroup?id=' + orgUnitId).then(data => data.data);
        }

        public saveTenderGroupId(orgUnitId: string, tenderGroupId: string) {
            return this.baseService.post('organization/{companyNumber}/tendergroup?id=' + orgUnitId + '&tenderGroupId=' + tenderGroupId, {}).then(data => data.data);
        }

        public getNtiCities() {
            return this.baseService.get('ntifm/{companyNumber}/getcities').then(data => data.data);
        }

        public getNtiEstates(cityId: number) {
            return this.baseService.get('ntifm/{companyNumber}/getestates?cityId=' + cityId).then(data => data.data);
        }

        public getNtiBuildings(cityId: number, estateId: number) {
            return this.baseService.get('ntifm/{companyNumber}/getbuildings?cityId=' + cityId + '&estateId=' + estateId).then(data => data.data);
        }
    }

    OrganizationService.$inject = ['$http', 'BaseService', '$q', 'CompanyService', '$timeout'];
    angular
        .module('eseebase')
        .service('OrganizationService', OrganizationService);
}